<template>
    <v-footer
        app
        dark
        absolute
        color="#333333"
        inset
    >
        <v-container fluid>
            <v-row>
                <v-col cols="12" md="6" class="white--text darken-1--text">
                    {{ (new Date()).getFullYear() }} - ODC {{getVersion()}}
                </v-col>
                <v-col cols="12" md="6" align="end">
                    <v-btn @click="openHall" small rounded outlined color="warning">
                        <v-icon>mdi-trophy-award</v-icon>Hall of Fame
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>
<script>
export default {
    methods:{
        openHall(){
            this.$emit('open-hall-of-fame')
            //window.open('/hallOfFame', '_blank')
        },
        getVersion(){
            return process.env.VUE_APP_SECRET_VERSION
        }
    }
}
</script>
